import DeleteIconButton from 'components/common/delete-icon-button';
import { Input } from 'components/elements';
import { useFormState } from 'components/elements/form';
import Text from 'components/elements/text';
import {
  CardSection,
  SeparatorHorizontal,
  SeparatorVertical,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useFormContext } from 'react-hook-form';

import CruiseAddOnsTable from './add-ons-table';
import GroupDetailTable from './group-detail-table';
import CruiseGuestTable from './guest-table';
import { ScheduleCardHeader } from '../../style';
import {
  CruisePurchaseDetailsItemFormType,
  CruisePurchaseFormType,
} from '../form-type';

interface Props {
  parentIndex?: number;
  onRemove: () => void;
  fieldLength: number;
}

export default function GuestCard(props: Props) {
  const { parentIndex = 0, onRemove, fieldLength } = props;
  const { t } = useTranslation();
  const { editable } = useFormState();
  const { setValue, getValues, trigger } =
    useFormContext<CruisePurchaseFormType>();

  const name = `cruisePurchases.${parentIndex}.cruisePurchaseDetails` as const;

  const guestName =
    `cruisePurchases.${parentIndex}.cruisePurchaseGuests` as const;

  const onAfterChangeGroup = React.useCallback(
    (checked: boolean) => {
      const details = getValues(name);
      const value = details[0];
      let _details: CruisePurchaseDetailsItemFormType[];
      if (checked) {
        _details = [
          { ...value, guestId: '', guestName: '', guestDetailId: '' },
        ];
      } else {
        _details = getValues(guestName)
          .map((guest) => {
            const _detail = details.map((detail) => {
              return {
                ...detail,
                basicFare: value?.basicFare,
                portCharge: value?.portCharge,
                tax: value?.tax,
                tipping: value?.tipping,
                cruiseRoomId: value?.cruiseRoomId,
                cruiseRoomName: value?.cruiseRoomName,
                cruiseRoomNumber: value?.cruiseRoomNumber,
                deck: value?.deck,
                guestId: guest.guestId,
                guestName: guest.guestName,
                description: value?.description,
                guestDetailId: guest.guestDetailId || guest.guestId,
              };
            });
            return _detail;
          })
          .flat();
      }
      setValue(name, _details);
      trigger(name);
    },
    [getValues, guestName, name, setValue, trigger],
  );

  return (
    <CardSection>
      <ScheduleCardHeader>
        <Text variant="HeadingXSmall">
          {t('cruise:cabin_detail')} {parentIndex + 1}
        </Text>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {/* <Input
            type="check-box"
            name={`cruisePurchases.${parentIndex}.isGroupedPrice`}
            label={t('ticketSales:grouped_price')}
            onAfterChange={onAfterChangeGroup}
            noMargin
          /> */}
          {(fieldLength || 0) > 1 && editable && (
            <>
              <SeparatorHorizontal $margin={16} />
              <DeleteIconButton
                onClick={onRemove}
                rootStyle={{ height: '32px' }}
              />
            </>
          )}
        </div>
      </ScheduleCardHeader>
      <SeparatorVertical $margin={24} />
      <CruiseGuestTable parentIndex={parentIndex} />
      <SeparatorVertical $margin={24} />
      <GroupDetailTable parentIndex={parentIndex} />
      <SeparatorVertical $margin={12} />
      <CruiseAddOnsTable parentIndex={parentIndex} />
    </CardSection>
  );
}
